import { Splide, SplideSlide } from "@splidejs/react-splide";
import "../../css/youtube.scss";
import { Link, useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import Fancybox from '../../helpers/Fancybox';
import { FiChevronLeft, FiChevronRight, FiPlay, FiImage } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

export default function Instagram({ instadata, logo }) {
  console.log("errrr", instadata)
  const ref = useRef();
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [visibleCount, setVisibleCount] = useState(8);

  return (<>
    <section className="bg-white">
      <div className="container">
        <div className="container mb-5">
          <h3 className="fw-bold text-dark">LATEST FROM INSTAGRAM</h3>
          <p className="text-secondary">Follow us on <strong>Instagram</strong> for daily inspiration, behind-the-scenes glimpses of temple life, festival photos, reels, and quotes from sacred scriptures.
            Join our growing devotional community online.</p>
        </div>
        <div className="row align-items-center mb-4 bg-light p-3 rounded">
          <div className="col-12 col-md-2 text-center mb-3 mb-md-0">
            <img
              src={logo}
              alt="Channel logo"
              className="rounded-circle img-fluid"
              height={117}
              width={117}
            />
          </div>
          <div className="col-12 col-md-7">
            <h2 className="temple-title">ISKCON ATTAPUR OFFICIAL</h2>
            <div className="subscribe-stats">
              <p>Non-profit organisation</p>
              <p>Hare Krishna!  Welcome to the official page of ISKCON Attapur, the abode of Sri Sri Radha Madhav.</p>
              <p className="inst-hare-text">#DivinityInYou #ISKCONAttapur</p>
              <p> <a href="https://www.iskconattapur.com/annadaan">www.iskconattapur.com/annadaan</a></p>

            </div>
          </div>
          <div className="col-12 col-md-3 text-center">



          </div>
        </div>
      </div>
      <div className="container">
        <section className="campaigns-wrap d-block d-md-none mb-5">
          <div className="row">
            <Splide
              className="testimonial-slider images-slider"
              ref={ref}
              options={{
                perPage: 4,
                perMove: 1,
                gap: 20,
                arrows: false,
                pagination: false,
                autoplay: true,
                speed: 1000,
                interval: 8000,
                breakpoints: {
                  576: { perPage: 1 },
                  768: { perPage: 2, trimSpace: true },
                  992: { perPage: 2 },
                  1024: { perPage: 3 },
                  1200: { perPage: 3 },
                  1400: { perPage: 4 },
                },
              }}
            >
              {instadata.map((data) => (
                <SplideSlide key={data.id}>
                  <div
                    className="inst-item overflow-hidden"
                    // onClick={() => setSelectedMedia(data)}
                    style={{
                      cursor: "pointer",
                      borderRadius: "12px",
                      overflow: "hidden",
                      height: "100%", // Optional
                    }}
                  >
                    {data.media_type === "VIDEO" ? (<>
                      <Fancybox>
                        <a data-fancybox="video" href={data.media_url} data-thumb={data.media_url}  >
                          <video
                            src={data.media_url}
                            className="w-100 h-100"
                            muted
                            autoPlay
                            loop
                            playsInline
                            style={{
                              objectFit: "cover",
                              borderRadius: "0", // avoid double rounding
                              height: "100%",
                              width: "100%",
                            }}
                          />
                        </a>
                      </Fancybox>
                    </>
                    ) : (
                        <Fancybox>
                        <a data-fancybox="video" href={data.media_url} data-thumb={data.media_url}  >
                      <img
                        src={data.media_url}
                        alt="Instagram post"
                        className="w-100 h-100"
                        style={{
                          objectFit: "cover",
                          borderRadius: "0",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                      </a>
                      </Fancybox>
                    )}


                    {/* 🔽 ICON OVERLAY */}
                    <div
                      className="position-absolute"
                      style={{
                        top: "10px",
                        right: "9px",
                        background: "rgba(0, 0, 0, 0.5)",
                        borderRadius: "50%",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                      }}
                    >
                      {data.media_type === "VIDEO" ? (
                        <FiPlay color="#fff" size={18} />
                      ) : (
                        <FiImage color="#fff" size={18}></FiImage>
                      )}
                    </div>
                  </div>
                </SplideSlide>

              ))}
            </Splide>

            <div className="arrow-wrap">
              <button
                className="slider-btn prev box-hover"
                onClick={() => ref.current.splide.go("-1")}
              >
                <FiChevronLeft />
              </button>
              <button
                className="slider-btn next box-hover"
                onClick={() => ref.current.splide.go("+1")}
              >
                <FiChevronRight />
              </button>
            </div>


          </div>
        </section>


        {/* <section className="campaigns-wrap container d-none d-md-block">
          <div className="row">
            {instadata.slice(0, visibleCount).map((data, index) => (
              <div key={data.id} className="col-md-3 col-sm-12 mb-4 d-flex justify-content-center">
                <div
                  className="inst-item overflow-hidden"
                  onClick={() => setSelectedMedia(data)}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    maxWidth: "300px",
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >
                  {data.media_type === "VIDEO" ? (
                    <video
                      src={data.media_url}
                      className="img-fluid w-100 h-100 object-cover"
                      muted
                      autoPlay
                      loop
                      playsInline
                      style={{
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={data.media_url}
                      alt="Instagram post"
                      className="img-fluid w-100 h-100"
                      style={{
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </section> */}

        <section className="campaigns-wrap container d-none d-md-block">
          <div className="row">
            {instadata.slice(0, visibleCount).map((data, index) => (
              <div key={data.id} className="col-md-3 col-sm-12 mb-4 d-flex justify-content-center">
                <div
                  className="inst-item position-relative overflow-hidden"
                  //onClick={() => setSelectedMedia(data)}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    maxWidth: "300px",
                    borderRadius: "12px",
                  }}
                >
                  {data.media_type === "VIDEO" ? (
                    <Fancybox>
                      <a data-fancybox="video" href={data.media_url} data-thumb={data.media_url}  >
                        <video
                          src={data.media_url}
                          className="w-100 h-100"
                          muted
                          autoPlay
                          loop
                          playsInline
                          style={{
                            objectFit: "cover",
                            borderRadius: "0", // avoid double rounding
                            height: "100%",
                            width: "100%",
                          }}
                        />
                      </a>
                    </Fancybox>
                  ) : (
                    <Fancybox>
                      <a data-fancybox="gallery" href={data.media_url} data-thumb={data.media_url}  >
                        <img
                          src={data.media_url}
                          alt="Instagram post"
                          className="img-fluid w-100 h-100"
                          style={{
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </a>
                    </Fancybox>
                  )}

                  {/* 🔽 ICON OVERLAY */}
                  <div
                    className="position-absolute"
                    style={{
                      top: "10px",
                      right: "9px",
                      background: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "50%",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                    }}
                  >
                    {data.media_type === "VIDEO" ? (
                      <FiPlay color="#fff" size={18} />
                    ) : (
                      <FiImage color="#fff" size={18}></FiImage>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>



        {visibleCount < instadata.length ? (
          <div className="col-12 d-flex justify-content-center">
            <div className="row d-flex justify-content-center gap-2">
              <div className="col-auto d-none d-md-block">
                <button
                  onClick={() => setVisibleCount((prev) => prev + 8)}
                  className="btn btn-dark text-white mb-2 rounded-0"
                >
                  Load more
                </button>
              </div>
              <div className="col-auto">
                <button
                  onClick={() =>
                    window.open("https://www.instagram.com/iskconattapur_hyderabad/", "_blank")
                  }
                  className="btn btn-dark text-white mb-2 rounded-0"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 448 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                  </svg>{' '}
                  Follow on Instagram
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 d-flex justify-content-center">
            <div className="row d-flex justify-content-center gap-2">
              <div className="col-auto">
                <button
                  onClick={() =>
                    window.open("https://www.instagram.com/iskconattapur", "_blank")
                  }
                  className="btn btn-dark text-white mb-2 rounded-0"
                >
                  Follow on Instagram
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  </>
  );
}
